import { createSelector } from 'reselect';
import { notificationRequestActionTypes } from '../actions/types';

const notificationRequests = (state = { byRuleId: {}}, action) => {
  switch (action.type) {
    case notificationRequestActionTypes.success:
      // Completely replace everything
      const newState = {};
      Object.values(action.response).forEach(v => {
        newState[v.rule_id] = v;
      });
      return { byRuleId: { ...newState }};
    default:
      return state;
  }
};
export default notificationRequests;

const getNotificationRequestsState = state => state.notificationRequests;
export const notificationRequestsByRuleId = state =>
  getNotificationRequestsState(state).byRuleId;
export const getNotificationRequestByRuleId = (state, id) =>
  notificationRequestsByRuleId(state)[id];

export const getNotificationRequests = createSelector(
  getNotificationRequestsState,
  (requestState) => Object.values(requestState.byRuleId)
);


// WEBPACK FOOTER //
// src/reducers/notificationRequests.js